// extracted by mini-css-extract-plugin
module.exports = {"cls1":"TaskWorklistsPage-CssProp13_td-module--cls1--Ku6Lg","cls2":"TaskWorklistsPage-CssProp13_td-module--cls2--si12d TaskWorklistsPage-CssProp13_td-module--cls1--Ku6Lg"};